import { userRequiresPolicyConsent } from "@/lib/lutely-api/hooks/usePolicyConsent";
import { userRequiresEmailVerification } from "@/lib/lutely-api/hooks/useEmailVerification";
import { useLoggedInUser } from "../providers/ApiProvider/hooks";
import PersonaPicker from "./PersonaPicker";
import { useIsPersonaPickerDisabled } from "./usePersonaPickerVisibility";

export const PersonaPickerContainer = () => {
  const { data: currentUser, isLoading, isFetching } = useLoggedInUser();
  const isDisabled = useIsPersonaPickerDisabled();

  // Don't show while loading or fetching
  if (isLoading || isFetching) {
    return null;
  }

  // Only show if user is authenticated (currentUser exists)
  if (!currentUser) {
    return null;
  }

  if (isDisabled) {
    return null;
  }

  // The policy consent modal goes first: with both dialogs open, this one's
  // scroll lock (mounted later) blocks scrolling inside the consent modal.
  if (userRequiresPolicyConsent(currentUser)) {
    return null;
  }

  // Same reason: the email verification gate is also blocking and sits above
  // this one in the chain.
  if (userRequiresEmailVerification(currentUser)) {
    return null;
  }

  // Show persona picker if user hasn't completed persona selection
  // Personas are completed if they exist in the profile as an array
  // Even an empty array indicates completion (user skipped the selection)
  const personasCompleted = Array.isArray(currentUser.profile?.personas);

  if (personasCompleted) {
    return null;
  }

  return <PersonaPicker />;
};
